// Un dato, un render (AGENTS.md): TODO saldo de socio se formatea con estos
// helpers, nunca inline por pantalla. Así murieron los "3 saldos distintos"
// de Gaia (ultrareview 08-2026: los 4 hallazgos eran esta misma clase).

export function balanceAmount(value) {
  return Number(value) || 0;
}

// Importe con formato único: "€-1.50" / "€12.00".
export function formatBalance(value) {
  return `€${balanceAmount(value).toFixed(2)}`;
}

// Etiqueta para listados: la deuda se DICE ("Debe €1.50"), el cero es "Sin saldo".
export function balanceListLabel(value) {
  const bal = balanceAmount(value);
  if (bal < 0) return `Debe €${Math.abs(bal).toFixed(2)}`;
  if (bal === 0) return 'Sin saldo';
  return formatBalance(bal);
}

// Clase de color: deuda y cero en rojo; el positivo lo elige cada contexto
// (verde en listados, neutro en fichas), pero rojo-para-deuda es innegociable.
//
// Los colores salen de los tokens y no de la paleta cruda de Tailwind. Valen lo
// mismo —`red-600` ES #dc2626 y `green-600` ES #16a34a—, así que no cambia un
// píxel; cambia el día que el token se mueva y este helper, que es la fuente
// única de este dato, se quedaría atrás sin que nadie se entere.
export function balanceToneClass(value, positiveClass = 'text-[var(--success)]') {
  const bal = balanceAmount(value);
  return bal < 0 || bal === 0 ? 'text-[var(--destructive)]' : positiveClass;
}

/**
 * Variante en píldora, para donde el saldo se presenta como chip y no como
 * texto: la lista de Entradas, la ficha de Club Entradas.
 *
 * Existe porque si no, cada pantalla se inventa su pareja fondo+texto y vuelve
 * el problema por la puerta de al lado: en Entradas el positivo iba en lima-50
 * sobre lima-700 —la marca que se revirtió— y en Club Entradas en gris.
 */
export function balanceChipClass(value) {
  const bal = balanceAmount(value);
  return bal < 0 || bal === 0
    ? 'bg-[var(--destructive-bg)] text-[var(--destructive)]'
    : 'bg-[var(--toast-success-bg)] text-[var(--success)]';
}
